import { render, staticRenderFns } from "./classReminder.vue?vue&type=template&id=4136be6a"
import script from "./classReminder.vue?vue&type=script&lang=js"
export * from "./classReminder.vue?vue&type=script&lang=js"
import style0 from "./classReminder.vue?vue&type=style&index=0&id=4136be6a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports